import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    partnerId: String,
  };

  connect() {
    this.fetchCartierJs().then(() => {
      window.MinisiteSettings = {
        partner: this.partnerIdValue,
        language: 'en-US',
      };

      // eslint-disable-next-line no-undef
      OcctooContainer({
        customer: 'cartier',
        container: 'minisite',
      }).mount('cartier-container');
    });
  }

  fetchCartierJs() {
    return new Promise((resolve, reject) => {
      if (typeof loadContainer !== 'function') {
        const script = document.createElement('script');
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = 'https://cdn.occtoo.com/occtoo/uxcontainer/v5/ux-container.min.js';
      } else {
        resolve();
      }
    });
  }
}
